module.exports = __webpack_public_path__ + "22e3cd356e351ca4f93ea8b8b4035854.fbx";